<div class="card w-full h-full flex flex-col shadow-sm p-6 rounded-2xl bg-white gap-8 overflow-y-auto">
    <div class="flex flex-row justify-between items-center">
        <div class="flex flex-col">
            <h1 class="font-semibold text-2xl text-gray-800">
                Perfil de Usuario
            </h1>
            <p class="text-gray-500 mt-1">
                Información detallada de tu cuenta.
            </p>
        </div>
        <div class="flex flex-col">
            <div (click)="facturacion()"
                class="rounded-3xl flex items-center gap-3 bg-orange-500 text-white py-4 px-8 cursor-pointer hover:bg-orange-600 active:bg-orange-700 transition-all"
                role="button" tabindex="0">
                <span class="text-base font-medium">Facturación</span>
                <i class="fi-rr-document text-xl flex"></i>
            </div>
        </div>
    </div>

    <!-- TABS -->
    <div class="border-b border-gray-200 mt-2 mb-2 w-full">
        <nav class="-mb-px flex space-x-8" aria-label="Tabs">
            <button (click)="switchTab('PROFILE')" [ngClass]="activeTab === 'PROFILE' 
                    ? 'border-orange-500 text-orange-600' 
                    : 'border-transparent text-gray-500 hover:border-gray-300 hover:text-gray-700'"
                class="whitespace-nowrap border-b-2 py-3 px-2 text-base font-medium transition-all duration-200 flex items-center gap-2">
                <i class="fi-rr-user text-lg"></i>
                Mi Perfil
            </button>

            <!-- TODO: update this tab action later -->
            <button (click)="switchTab('OTHER')" [ngClass]="activeTab === 'OTHER' 
                    ? 'border-orange-500 text-orange-600' 
                    : 'border-transparent text-gray-500 hover:border-gray-300 hover:text-gray-700'"
                class="whitespace-nowrap border-b-2 py-3 px-2 text-base font-medium transition-all duration-200 flex items-center gap-2">
                <i class="fi-rr-label text-lg"></i>
                Descuentos
            </button>
        </nav>
    </div>

    <ng-container *ngIf="activeTab === 'PROFILE'">
        <!-- Usuario Reference -->
        <div class="flex flex-col gap-1" *ngIf="user()">
            <h2 class="px-3 py-0.5 text-left font-semibold text-base border-b border-gray-300 pb-1">USUARIO
                <span class="text-base">{{ getDisplayRole() }}</span>
            </h2>
            <div class="grid grid-cols-1 sm:grid-cols-3 gap-0.5">
                <div class="flex flex-col gap-0.5">
                    <span class="px-4 py-1 text-left font-semibold text-base text-gray-600">Nombre</span>
                    <span class="px-6 py-1">{{ user()?.user?.name }}</span>
                </div>
                <div class="flex flex-col gap-0.5">
                    <span class="px-4 py-1 text-left font-semibold text-base text-gray-600">Correo</span>
                    <span class="px-6 py-1">{{ user()?.user?.email }}</span>
                </div>
            </div>
        </div>

        <!-- Bodegas del Comprador -->
        <div class="flex flex-col gap-1" *ngIf="isBuyer && buyerWarehouses().length > 0">
            <h2 class="px-3 py-0.5 text-left font-semibold text-base border-b border-gray-300 pb-1">BODEGAS</h2>
            <p class="px-4 py-1 text-sm text-gray-500">Selecciona la bodega con la que deseas trabajar</p>
            <div class="grid grid-cols-1 sm:grid-cols-2 gap-2 px-4 py-2">
                <div *ngFor="let warehouse of buyerWarehouses()" 
                    (click)="selectWarehouse(warehouse.code!)"
                    class="warehouse-card p-3 rounded-xl border-2 cursor-pointer transition-all duration-200"
                    [ngClass]="isSelected(warehouse.code!) ? 'border-orange-500 bg-orange-50' : 'border-gray-200 hover:border-orange-300 hover:bg-gray-50'">
                    <div class="flex items-center justify-between">
                        <div class="flex items-center gap-2">
                            <i *ngIf="isSelected(warehouse.code!)" class="fi-rr-check-circle text-xl text-orange-500"></i>
                            <div class="flex flex-col">
                                <span class="font-semibold text-sm"
                                    [ngClass]="isSelected(warehouse.code!) ? 'text-orange-700' : 'text-gray-800'">
                                    {{ warehouse.name }}
                                </span>
                                <span class="text-xs text-gray-500">{{ warehouse.code }}</span>
                            </div>
                        </div>
                        <span class="text-xs px-2 py-0.5 rounded-full"
                            *ngIf="isSelected(warehouse.code!)"
                            [ngClass]="'bg-orange-500 text-white'">
                            Activa
                        </span>
                    </div>
                </div>
            </div>
        </div>

        <!-- Cliente Reference -->
        <div class="flex flex-col gap-1" *ngIf="customer() || creditTerms()">
            <h2 class="px-3 py-1 text-left font-semibold text-base border-b border-gray-300 pb-1">CLIENTE</h2>
            <div class="grid grid-cols-1 sm:grid-cols-4 gap-0.5">
                <div class="flex flex-col gap-0.5" *ngIf="customer()">
                    <span class="px-4 py-1 text-left font-semibold text-base text-gray-600">Nombre</span>
                    <span class="px-6 py-1">{{ customer()?.name }}</span>
                </div>
                <div class="flex flex-col gap-0.5" *ngIf="creditTerms()">
                    <span class="px-4 py-1 text-left font-semibold text-base text-gray-600">Cupo</span>
                    <span class="px-6 py-1">${{ creditTerms()?.creditLimit | number:'1.2-2'
                        }}</span>
                </div>
                <div class="flex flex-col gap-0.5" *ngIf="cupoDisponible() !== null">
                    <span class="px-4 py-1 text-left font-semibold text-base text-gray-600">Cupo Disponible</span>
                    <span class="px-6 py-1">${{ cupoDisponible() | number:'1.2-2' }}</span>
                </div>
                <div class="flex flex-col gap-0.5" *ngIf="creditTerms()">
                    <span class="px-4 py-1 text-left font-semibold text-base text-gray-600">Forma Pago (días
                        crédito)</span>
                    <span class="px-6 py-1">{{ creditTerms()?.paymentMethod }}</span>
                </div>
            </div>
        </div>
        <div *ngIf="!user()" class="flex justify-center items-center h-32">
            <span class="text-gray-500">Cargando información del usuario...</span>
        </div>
    </ng-container>

    <ng-container *ngIf="activeTab === 'OTHER'">
        <!-- Descuentos -->
        <div class="flex flex-col gap-1" *ngIf="discounts() && discounts().length > 0">
            <h2 class="px-3 py-0.5 text-left font-semibold text-base">DESCUENTOS</h2>
            <div class="w-full max-h-[450px] overflow-y-auto pr-2 custom-scrollbar" style="overflow-x: hidden;">
                <table class="w-full table-auto border-collapse table-sticky">
                    <thead>
                        <tr class="bg-gray-50 border-b border-gray-200">
                            <th class="px-4 py-2 text-left font-semibold text-base text-gray-600">Item</th>
                            <th class="px-4 py-2 text-left font-semibold text-base text-gray-600">Descripción</th>
                            <th class="px-4 py-2 text-left font-semibold text-base text-gray-600">Ventas</th>
                            <th class="px-4 py-2 text-left font-semibold text-base text-gray-600">Descuento</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr *ngFor="let discount of discounts()"
                            class="border-b border-gray-100 hover:bg-gray-50 last:border-b-0">
                            <td class="px-6 py-4">
                                {{ discount.itemId }}
                            </td>
                            <td class="px-6 py-4">
                                {{ discount.itemDescription }}
                            </td>
                            <td class="px-6 py-4">
                                {{ discount.ventaM3 }} {{ discount.uom }}
                            </td>
                            <td class="px-6 py-4">
                                {{ discount.discountPercentage }}%
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
        <!-- Si NO hay descuentos -->
        <div *ngIf="!discounts() || discounts().length === 0"
            class="flex flex-col items-center justify-center py-12 px-4 text-center">
            <div class="w-16 h-16 bg-gray-100 rounded-2xl flex items-center justify-center mb-4">
                <i class="fi-rr-label text-2xl text-gray-400"></i>
            </div>
            <h3 class="text-lg font-semibold text-gray-800 mb-1">No tiene descuentos disponibles</h3>
            <p class="text-sm text-gray-500">No hay descuentos activos para mostrar.</p>
        </div>
    </ng-container>
</div>